// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function createPropsGetter(defaultProps) {
  return function () {
    return this.props;
  };
}